import React from "react"
import CurrencyInput from "./input"
import MetadataLayout from "../form-input/layout-metadata"

export default function(props) {
    return <MetadataLayout {...props}>
        <CurrencyInput {...props}/>
    </MetadataLayout>
}
